import {
    ACTIVATE_TAB,
    WORK_AT_RECYCLE_BIN,
    CHANGE_MODE,
    CLEAR_DATA,
    CLEAR_FORM_AND_IMAGE_MAPPER,
    DELETE_DEPEND_DOCUMENT,
    DELETE_DEPEND_DOCUMENT_FAILED,
    DELETE_DEPEND_DOCUMENT_SUCCESS,
    DOWNLOAD_DEPENDANT_DOCUMENT,
    DOWNLOAD_DEPENDANT_DOCUMENT_FAILED,
    DOWNLOAD_DEPENDANT_DOCUMENT_SUCCESS,
    DOWNLOAD_DOCUMENT,
    DOWNLOAD_DOCUMENT_FAILED,
    DOWNLOAD_DOCUMENT_LINK,
    DOWNLOAD_DOCUMENT_LINK_FAILED,
    DOWNLOAD_DOCUMENT_LINK_SUCCESS,
    DOWNLOAD_DOCUMENT_SUCCESS,
    EDIT_DOCUMENT,
    EDIT_DOCUMENT_FAILED,
    EDIT_DOCUMENT_SUCCESS,
    FOCUS_ON_FIELD_IN_IMAGE,
    GET_DETAIL_DOCUMENT_HISTORY,
    GET_DETAIL_DOCUMENT_HISTORY_FAILED,
    GET_DETAIL_DOCUMENT_HISTORY_SUCCESS,
    GET_DOCUMENT_SERVICE_API_V2_DOCUMENT_SUCCESS,
    LIST_FOLDER_BY_GROUP_SUCCESS,
    MAP_FORM_AND_IMAGE,
    MASS_UPDATE_DOCUMENT,
    MASS_UPDATE_DOCUMENT_FAILED,
    MASS_UPDATE_DOCUMENT_SUCCESS,
    ON_CHANGE_DATA,
    REDIRECT_BACK,
    SCROLL_FORM_OR_IMAGE,
    SHARE_DOCUMENT,
    SHARE_DOCUMENT_FAILED,
    SHARE_DOCUMENT_SUCCESS,
    UPLOAD_DEPEND_DOCUMENT,
    UPLOAD_DEPEND_DOCUMENT_FAILED,
    UPLOAD_DEPEND_DOCUMENT_SUCCESS,
    GET_DOCUMENT_ID,
    GET_DOCUMENT_ID_FAILED,
    GET_DOCUMENT_ID_SUCCESS,
    VIEW_CHILD_DOCUMENT,

    EMPTY_RECYCLE_BIN,
    EMPTY_RECYCLE_BIN_SUCCESS,
    EMPTY_RECYCLE_BIN_FAILED,

    GET_REASON_ID,
    GET_REASON_ID_FAILED,
    GET_REASON_ID_SUCCESS,
    GET_PARKING_ID,
    GET_PARKING_ID_FAILED,
    GET_PARKING_ID_SUCCESS,

    VALIDATE_CONTRACT_NUMBER,
    VALIDATE_CONTRACT_NUMBER_FAILED,
    VALIDATE_CONTRACT_NUMBER_SUCCESS,
    VALIDATE_SHIPPING_DOCUMENT,
    VALIDATE_SHIPPING_DOCUMENT_FAILED,
    VALIDATE_SHIPPING_DOCUMENT_SUCCESS
} from './constants';
import {cloneDeep} from 'lodash';
import {Constants} from '../constants'

const INIT_DETAIL_DOCUMENT = {
    entity: null,
    loading: false,
    error: null,
    loaded: false,
    mode: Constants.ActionMode.View | Constants.ActionMode.Edit | Constants.ActionMode.History,
    showInvoiceItem: false,
    fieldInImage: {},
    formAndImageMapper: {},
    folders: [],

    histories: {
        entity: null,
        entities: [],
        loading: false,
        error: null,
        loaded: false,
    }
}

const INIT_LINKED_DATA = {
    documentIDs: [],
    loading: false,
    error: null
}

const INIT_VALIDATOR = {
    valid: true,
    message: '',
    loading: false,
    error: null
}

const INIT_SELECTION_DATA = {
    data: [],
    loading: false,
    error: null
}

const INIT_STATE = {
    loadingScreen: false,

    isDataChanged: false,
    detail: INIT_DETAIL_DOCUMENT,
    child: INIT_DETAIL_DOCUMENT,
    folders: [],
    dependDocuments: {
        page: 1,
        sizePerPage: 10,
        searchText: '',
        entities: [],
        total: 0,
        entity: {},
        loading: false,
    },
    tab: 0,
    errorEntity: undefined,
    shouldRedirectBack: false,
    contractNumberState: INIT_VALIDATOR,
    shippingDocumentState: INIT_VALIDATOR,

    reasonIDState: INIT_SELECTION_DATA,
    parkingIDState: INIT_SELECTION_DATA,

    massUpdateState: {
        error: null,
        redirectMassUpdateLog: false
    },

    workAtRecycleBin: false
};

const documentDetailReducers = (state = INIT_STATE, action) => {
    switch (action.type) {
        case LIST_FOLDER_BY_GROUP_SUCCESS:
            let folders = action.payload && action.payload.response ? action.payload.response : null;
            folders = folders && folders.folder ? folders.folder : null;
            return {...state, folders};
        case CLEAR_DATA:
            return {...state, ...cloneDeep(INIT_STATE)};
        case WORK_AT_RECYCLE_BIN:
            return {...state, workAtRecycleBin: action.payload};
        case ON_CHANGE_DATA:
            const isValid = action.payload === undefined ? state.isValid : action.payload
            return {...state, isDataChanged: true, isValid: isValid};
        case ACTIVATE_TAB:
            return {...state, tab: action.payload};
        case CHANGE_MODE:
            return {
                ...state,
                isDataChanged: false,
                contractNumberState: INIT_VALIDATOR,
                shippingDocumentState: INIT_VALIDATOR,
                reasonIDState: INIT_SELECTION_DATA,
                parkingIDState: INIT_SELECTION_DATA,
            };
        case VIEW_CHILD_DOCUMENT:
            return {
                ...state,
                child: {
                    ...state.child,
                    entity: null
                },
                viewChild: action.payload
            };
        case GET_DOCUMENT_SERVICE_API_V2_DOCUMENT_SUCCESS:
            if (state.viewChild) {
                return {
                    ...state,
                    isDataChanged: false,
                    child: {
                        ...state.child,
                        entity: action.payload, loading: false, error: null, loaded: true
                    }
                };
            } else {
                return {
                    ...state,
                    isDataChanged: false,
                    detail: {
                        ...state.detail,
                        entity: action.payload, loading: false, error: null, loaded: true
                    }
                };
            }
        case EDIT_DOCUMENT:
            return {...state, loading: true, error: null, errorEntity: null, shouldRedirectBack: false};
        case EDIT_DOCUMENT_SUCCESS:
            if (state.viewChild) {
                return {
                    ...state,
                    child: {
                        ...state.child,
                        entity: action.payload, loading: false, error: null, loaded: true
                    },
                    error: null, errorEntity: null, shouldRedirectBack: true
                };
            } else {
                return {
                    ...state,
                    detail: {
                        ...state.detail,
                        entity: action.payload, loading: false, error: null, loaded: true
                    },
                    error: null, errorEntity: null, shouldRedirectBack: true
                };
            }
        case EDIT_DOCUMENT_FAILED:
            return {
                ...state,
                error: action.payload.error,
                errorEntity: action.payload.errorEntity,
                loading: false,
                shouldRedirectBack: false
            };
        case REDIRECT_BACK:
            return {...state, shouldRedirectBack: false};
        case GET_DETAIL_DOCUMENT_HISTORY:
            if (state.viewChild) {
                return {
                    ...state,
                    child: {
                        ...state.child,
                        histories: {
                            entities: [], loading: true, error: null
                        }
                    }
                };
            } else {
                return {
                    ...state,
                    detail: {
                        ...state.detail,
                        histories: {
                            entities: [], loading: true, error: null
                        }
                    }
                };
            }
        case GET_DETAIL_DOCUMENT_HISTORY_SUCCESS:
            if (state.viewChild) {
                return {
                    ...state,
                    child: {
                        ...state.child,
                        histories: {
                            ...state.child.history,
                            entities: action.payload, loading: false, error: null
                        }
                    }
                };
            } else {
                return {
                    ...state,
                    detail: {
                        ...state.detail,
                        histories: {
                            ...state.detail.history,
                            entities: action.payload, loading: false, error: null
                        }
                    }
                };
            }
        case GET_DETAIL_DOCUMENT_HISTORY_FAILED:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    histories: {
                        ...state.detail.history,
                        loading: false, error: action.payload
                    }
                }
            };
        case FOCUS_ON_FIELD_IN_IMAGE:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    fieldInImage: action.payload
                }
            };
        case MAP_FORM_AND_IMAGE:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    formAndImageMapper: {...state.detail.formAndImageMapper, ...action.payload}
                }
            };
        case SCROLL_FORM_OR_IMAGE:
            const formAndImageMapper = {...state.detail.formAndImageMapper}
            if (action.payload.currentImageOffset !== undefined) {
                formAndImageMapper['currentImageOffset'] = action.payload.currentImageOffset
            }
            if (action.payload.currentFormOffset !== undefined) {
                formAndImageMapper['currentFormOffset'] = action.payload.currentFormOffset
            }
            return {
                ...state,
                detail: {
                    ...state.detail,
                    formAndImageMapper: formAndImageMapper
                }
            };
        case CLEAR_FORM_AND_IMAGE_MAPPER:
            return {
                ...state,
                detail: {
                    ...state.detail,
                    fieldInImage: null,
                    formAndImageMapper: null
                }
            };

        case UPLOAD_DEPEND_DOCUMENT:
            return {
                ...state,
                dependDocuments: {
                    loading: true, error: null
                }
            };
        case UPLOAD_DEPEND_DOCUMENT_SUCCESS:
            return {
                ...state,
                dependDocuments: {
                    loading: false, error: null
                }
            };
        case UPLOAD_DEPEND_DOCUMENT_FAILED:
            return {
                ...state,
                dependDocuments: {
                    error: action.payload, loading: false
                }
            };
        case DELETE_DEPEND_DOCUMENT:
            return {
                ...state,
                dependDocuments: {
                    ...state.dependDocuments,
                    loading: true
                }
            };
        case DELETE_DEPEND_DOCUMENT_SUCCESS:
            return {
                ...state,
                dependDocuments: {
                    ...state.dependDocuments,
                    entity: {}, loading: false, error: null
                }
            };
        case DELETE_DEPEND_DOCUMENT_FAILED:
            return {
                ...state,
                dependDocuments: {
                    ...state.dependDocuments,
                    error: action.payload, loading: false
                }
            };
        case GET_DOCUMENT_ID:
            let newState = {
                documentIDs: [],
                loading: true,
                error: null
            }
            if (action.payload.template === Constants.Template.SupplierContract) {
                return {
                    ...state,
                    contractNumberState: newState
                };
            } else {
                return {
                    ...state,
                    shippingDocumentState: newState
                };
            }
        case GET_DOCUMENT_ID_SUCCESS:
            newState = {
                documentIDs: action.payload.data,
                loading: false,
                error: null
            }
            if (action.payload.template === Constants.Template.SupplierContract) {
                return {
                    ...state,
                    contractNumberState: newState
                };
            } else {
                return {
                    ...state,
                    shippingDocumentState: newState
                };
            }
        case GET_DOCUMENT_ID_FAILED:
            newState = {
                documentIDs: [],
                loading: false,
                error: action.payload.data
            }
            if (action.payload.template === Constants.Template.SupplierContract) {
                return {
                    ...state,
                    contractNumberState: newState
                };
            } else {
                return {
                    ...state,
                    shippingDocumentState: newState
                };
            }
        case MASS_UPDATE_DOCUMENT:
            return {
                ...state,
                loadingScreen: true,
                massUpdateState: {
                    error: null
                }
            };
        case MASS_UPDATE_DOCUMENT_SUCCESS:
            return {
                ...state,
                loadingScreen: false,
                massUpdateState: {
                    error: null,
                    redirectMassUpdateLog: true
                }
            };
        case MASS_UPDATE_DOCUMENT_FAILED:
            return {
                ...state,
                loadingScreen: false,
                massUpdateState: {
                    error: action.payload
                }
            };
        case SHARE_DOCUMENT:
            return {...state, loadingScreen: true};
        case SHARE_DOCUMENT_SUCCESS:
            return {...state, loadingScreen: false};
        case SHARE_DOCUMENT_FAILED:
            return {...state, loadingScreen: false};
        case DOWNLOAD_DOCUMENT:
        case DOWNLOAD_DOCUMENT_LINK:
            return {...state, loadingScreen: true};
        case DOWNLOAD_DOCUMENT_SUCCESS:
        case DOWNLOAD_DOCUMENT_LINK_SUCCESS:
            return {...state, loadingScreen: false};
        case DOWNLOAD_DOCUMENT_FAILED:
        case DOWNLOAD_DOCUMENT_LINK_FAILED:
            return {...state, loadingScreen: false};
        case DOWNLOAD_DEPENDANT_DOCUMENT:
            return {
                ...state,
                dependDocuments: {
                    ...state.dependDocuments,
                    loading: true
                }
            };
        case DOWNLOAD_DEPENDANT_DOCUMENT_SUCCESS:
            return {
                ...state,
                dependDocuments: {
                    ...state.dependDocuments,
                    loading: false
                }
            };
        case DOWNLOAD_DEPENDANT_DOCUMENT_FAILED:
            return {
                ...state,
                dependDocuments: {
                    ...state.dependDocuments,
                    loading: false
                }
            };
        case EMPTY_RECYCLE_BIN:
            return {...state, loadingScreen: true};
        case EMPTY_RECYCLE_BIN_SUCCESS:
        case EMPTY_RECYCLE_BIN_FAILED:
            return {...state, loadingScreen: false};
        case GET_REASON_ID:
            newState = {
                data: [],
                loading: true,
                error: null
            }
            return {
                ...state,
                reasonIDState: newState
            };
        case GET_REASON_ID_SUCCESS:
            newState = {
                data: action.payload,
                loading: false,
                error: null
            }
            return {
                ...state,
                reasonIDState: newState
            };
        case GET_REASON_ID_FAILED:
            newState = {
                data: [],
                loading: false,
                error: action.payload
            }
            return {
                ...state,
                reasonIDState: newState
            };
        case GET_PARKING_ID:
            newState = {
                data: [],
                loading: true,
                error: null
            }
            return {
                ...state,
                parkingIDState: newState
            };
        case GET_PARKING_ID_SUCCESS:
            newState = {
                data: action.payload,
                loading: false,
                error: null
            }
            return {
                ...state,
                parkingIDState: newState
            };
        case GET_PARKING_ID_FAILED:
            newState = {
                data: [],
                loading: false,
                error: action.payload
            }
            return {
                ...state,
                parkingIDState: newState
            };
        case VALIDATE_CONTRACT_NUMBER:
            return {
                ...state,
                contractNumberState: {
                    valid: false,
                    message: '',
                    loading: true,
                    error: null
                }
            };
        case VALIDATE_CONTRACT_NUMBER_SUCCESS:

            return {
                ...state,
                contractNumberState: {
                    ...action.payload,
                    loading: false
                }
            };
        case VALIDATE_CONTRACT_NUMBER_FAILED:
            return {
                ...state,
                contractNumberState: {
                    valid: false,
                    message: '',
                    loading: false,
                    error: action.payload
                }
            };
        case VALIDATE_SHIPPING_DOCUMENT:
            return {
                ...state,
                shippingDocumentState: {
                    valid: false,
                    message: '',
                    loading: true,
                    error: null
                }
            };
        case VALIDATE_SHIPPING_DOCUMENT_SUCCESS:

            return {
                ...state,
                shippingDocumentState: {
                    ...action.payload,
                    loading: false
                }
            };
        case VALIDATE_SHIPPING_DOCUMENT_FAILED:
            return {
                ...state,
                shippingDocumentState: {
                    valid: false,
                    message: '',
                    loading: false,
                    error: action.payload
                }
            };
        default:
            return {...state};
    }
};

export default documentDetailReducers;
